module.exports = __webpack_public_path__ + "static/media/vvd-logo-02a-1x.3192b459.webp";